import React from "react";
import { ThemeProvider } from "styled-components";

const CWBRTheme = {
  // CSS attributes
  "font-family": "'Open Sans', sans-serif",

  //Font Sizes
  "xxl-font-size": "20px",
  "xl-font-size": "18px",
  "lg-font-size": "16px",
  "font-size": "14px",
  "s-font-size": "13px",
  "xs-font-size": "12px",
  "xxs-font-size": "11px",
  "placeholder-font": "10px",
  "sm-cb-font": "8px",

  //Font-weights
  "font-weight": "bold",
  "font-weight-800": "800",
  "font-weight-600": "600",

  //colors
  color: "#364866",
  darkBlue: "#00AAFF",
  lightBlue: "#2ED2FF",
  btnBlue: "#03C0FA",
  btnDarkBlue: "#00A2E0",
  placeHolderColor: "#8A94A6",
  white: "#FFFFFF",
  red: "#FEF6F6",
  errorColor: "#AF5756",
  darkGrey: "#122640",
  backgroundColor: "#EDF0F6",
  backgroundDisabled: "#F7F8FA",
  "disabled-grey": "#C9CED6",
  "red-border": "1px solid #FF1870",
  "error-border": "1px solid #AF5756",

  dropDown: {
    "font-size": "12px",
    "font-weight": "600",
    border: "1px solid #D3DDE9",
    "border-radius": "4px",
    "border-color": "#D3DDE9"
  },

  // Sub-themes
  formField: {
    color: "#0A1F44",
    "font-size": "13px",
    "font-weight": 600,

    outline: "#C9CED6",

    disabled: {
      color: "#E1E4E8"
    }
  }
};

export const withTheme = children => (
  <ThemeProvider theme={CWBRTheme}>{children}</ThemeProvider>
);

export default CWBRTheme;
